import axios from "../../../axios";
import download from "downloadjs";

export const downloadBot = async (bot_id, version_number, flow_name) => {
  try {
    let fileName = `${flow_name}-${version_number}.zip`;
    let options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "arraybuffer",
    };
    let { data } = await axios.get(
      `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/versions/download/?bot_id=${bot_id}&version_number=${version_number}`,
      options
    );
    download(data, fileName, "application/zip");
    return data;
  } catch (e) {
    console.log("errors", e);
  }
};
